import { memo } from 'react'
import { Card, CardContent, Box } from '@mui/material'
import MappingEditor from './MappingEditor'
import { useTranslationMapDetailsContext } from '../../contexts/TranslationMapDetailsContext'

export interface MappingViewProps {}

const MappingView = memo(function MappingView(_props: MappingViewProps) {
  const { translationMap, viewMode } = useTranslationMapDetailsContext()

  // Early return if context values are not available
  if (!translationMap) {
    return <div>Loading...</div>
  }

  return (
    <Box>
      {/* Mapping Editor - Now only shows artifact/code management */}
      <Card sx={{ height: '100%' }}>
        <CardContent sx={{ p: 0, height: '100%' }}>
          <MappingEditor />
        </CardContent>
      </Card>
    </Box>
  )
})

export default MappingView
